import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-货物行李",
  "use": "icon-货物行李-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-货物行李\">\r\n<path d=\"M182.3,51.8L104.2,11c-2.6-1.3-5.7-1.3-8.2,0L17.7,51.1c-3,1.5-4.8,4.6-4.8,8v83c0,3.4,1.9,6.5,4.9,8.1L96,189.1\r\n\tc1.2,0.7,2.7,0.9,4,0.9c1.4,0,2.7-0.3,4-0.9l78.2-38.9c3-1.5,4.9-4.6,4.9-8.1V59.7C187.2,56.4,185.3,53.3,182.3,51.8z M175,64.4\r\n\tv75.7l-68.9,34.3V101L175,64.4z M164.5,56.2L99.3,91L70.6,76.8l65.9-35.3L164.5,56.2z M31.7,57.6L100,22.6l23.4,12.2L57.3,70.2\r\n\tL31.7,57.6z M58.3,117.6c3.3,0,6.1-2.7,6.1-6.1V87.3l29.6,14.6v72.7L25,140.1V67.9l27.1,13.4v30.2C52.1,114.9,54.9,117.6,58.3,117.6\r\n\tz\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/货物行李.svg
// module id = 5YJo
// module chunks = 15